import Grid from '@mui/material/Grid';
import { styled } from '@mui/material/styles';

export const SortContainer = styled(Grid)(({ theme }) => ({
	paddingTop: theme.spacing(2),
	paddingBottom: theme.spacing(2),
}));
